var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"lg-context-nav",class:{ expandedContextNav: _vm.expandedMenu },attrs:{"aria-label":"Secondary"}},[_vm._l((_vm.secondaryNavigationList),function(route){return [(!route.hidden)?_c('router-link',{key:route.name,attrs:{"to":_vm.pathRelativeLevel + route.path}},[_vm._v("\n\t\t\t"+_vm._s(route.name)+"\n\t\t")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }